// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XY0S","controls":"styles_controls__2GojE","charLimit":"styles_charLimit__Lh_6l","input":"styles_input__D2N9I","send":"styles_send__SiQ0E"};